import { render, staticRenderFns } from "./JSuperQuery.vue?vue&type=template&id=5ebc2214&scoped=true"
import script from "./JSuperQuery.vue?vue&type=script&lang=js"
export * from "./JSuperQuery.vue?vue&type=script&lang=js"
import style0 from "./JSuperQuery.vue?vue&type=style&index=0&id=5ebc2214&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebc2214",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ebc2214')) {
      api.createRecord('5ebc2214', component.options)
    } else {
      api.reload('5ebc2214', component.options)
    }
    module.hot.accept("./JSuperQuery.vue?vue&type=template&id=5ebc2214&scoped=true", function () {
      api.rerender('5ebc2214', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/JSuperQuery.vue"
export default component.exports